import { Trans, useTranslation } from 'react-i18next';
import s from './index.module.scss';

export const HowItWorks = () => {
  const { t } = useTranslation('reporting-modes');
  return (
    <div className={s.wrapper}>
      <h3 className="f-hero-h4">{t('how.title')}</h3>
      <div className={s.cards}>
        <div className={s.card}>
          <div className="f-article-accent">{t('how.pick_mode')}</div>
          <div className="f-body-regular">
            {t('how.onboarding')}
            <ul className={s.list}>
              <li>
                <Trans
                  ns="reporting-modes"
                  i18nKey="how.transparent_desc"
                  components={{
                    Span: <span className="f-500" />,
                  }}
                />
              </li>
              <li>
                <Trans
                  ns="reporting-modes"
                  i18nKey="how.opaque_desc"
                  components={{
                    Span: <span className="f-500" />,
                  }}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={s.card}>
          <div className="f-article-accent">{t('how.upload_package')}</div>
          <div className="f-body-regular">
            <div>
              <div>{t('how.reporting_section')}</div>
              <ul className={s.list}>
                <li>{t('how.reporting_window')}</li>
                <li>{t('how.due_date')}</li>
                <li>{t('how.required_documents')}</li>
              </ul>
            </div>
            <div style={{ marginTop: '16px' }}>{t('how.you_upload')}</div>
            <ul className={s.list}>
              <li>{t('how.bank_statements')}</li>
              <li>{t('how.financial_statements')}</li>
            </ul>
            <div style={{ marginTop: '16px' }}>{t('how.file_formats')}</div>
          </div>
        </div>

        <div className={s.card}>
          <div className="f-article-accent">{t('how.review_confirm')}</div>
          <div className="f-body-regular">
            {t('how.review_process')}
            <br />
            <br />
            {t('how.status_dashboard')}
          </div>
        </div>

        <div className={s.card}>
          <div className="f-article-accent">{t('how.fees_mode_changes')}</div>
          <div className="f-body-regular">
            <div>
              <Trans
                ns="reporting-modes"
                i18nKey="how.late_package"
                components={{
                  Span: <span className="f-500" />,
                }}
              />
            </div>
            <ul className={s.list}>
              <li>
                <Trans
                  ns="reporting-modes"
                  i18nKey="how.in_transparent_mode"
                  components={{
                    Span: <span className="f-500" />,
                  }}
                />
              </li>
              <li>
                <Trans
                  ns="reporting-modes"
                  i18nKey="how.in_opaque_mode"
                  components={{
                    Span: <span className="f-500" />,
                  }}
                />
              </li>
            </ul>
            <div style={{ marginTop: '16px' }}>
              <Trans
                ns="reporting-modes"
                i18nKey="how.monthly_service_fee_charged"
                components={{
                  Span: <span className="f-500" />,
                }}
              />
            </div>
            <div style={{ marginTop: '16px' }}>
              <Trans
                ns="reporting-modes"
                i18nKey="how.switch_back"
                components={{
                  Span: <span className="f-500" />,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
